import React from 'react';
import { useObserver } from 'mobx-react-lite';

import { useStore } from 'hooks/useStore';
import { NotificationStyle } from 'styles/NotificationStyle';
import { theme } from 'styles/theme';
import { css } from '@emotion/react';

export const Notifications = () => {
	const { notifications } = useStore();

	return useObserver(() => (
		<div
			css={css`
				position: fixed;
				right: 16px;
				top: 16px;
				min-height: 20px;
				z-index: 9990;

				&:hover {
					cursor: pointer;
				}
			`}
		>
			{notifications.queue.map(({ title, message, id }) => {
				return (
					<div
						key={id}
						css={NotificationStyle()}
						onClick={() => notifications.removeNotification(id)}
					>
						{!!title && (
							<div
								css={css`
									font-weight: 600;
									color: ${theme.color.success['400']};
									margin-bottom: 4px;
								`}
							>
								{title}
							</div>
						)}
						{message}
					</div>
				);
			})}
		</div>
	));
};
